var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group w-auto"},[_c('input',{staticClass:"form-control",attrs:{"autocomplete":"off","type":"search","name":"search","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }